// import {
//     POST_SCHEDULE_BOOKING_REQUEST,
//     POST_SCHEDULE_BOOKING_SUCCESS,
//     POST_SCHEDULE_BOOKING_FAIL,
//     CHECK_AVAILABILITY_REQUEST,
//     CHECK_AVAILABILITY_SUCCESS,
//     CHECK_AVAILABILITY_FAIL,
//     FIND_NEAREST_DRIVER_REQUEST,
//     FIND_NEAREST_DRIVER_SUCCESS,
//     FIND_NEAREST_DRIVER_FAIL,
//     RESET_SCHEDULE_BOOKING_FORM,
// } from '../constants/ScheduleBookingConstants'

// import ScheduleBookingService from '../services/ScheduleBookingService'


// export { fetchWorkAreas as GetAllWorkAreas } from './WorkAreaActions'
// export { fetchVehicles  as GetAllVehicles  } from './VehicleActions'

// export const CheckVehicleAvailability = (vid, bdate, startTime, endTime) => async (dispatch) => {
//     dispatch({ type: CHECK_AVAILABILITY_REQUEST })
//     try {
//         const fmt = (t) => t.split(':').length === 2 ? `${t}:00` : t
//         const res = await ScheduleBookingService.CheckVehicleAvailability(vid, bdate, fmt(startTime), fmt(endTime))
//         const isAvailable = res?.data?.resultSet?.[0]?.Availability === 'Available'
//         dispatch({ type: CHECK_AVAILABILITY_SUCCESS, payload: isAvailable })
//         return isAvailable
//     } catch (error) {
//         dispatch({ type: CHECK_AVAILABILITY_FAIL, payload: error?.response?.data?.message || error.message })
//         return false
//     }
// }

// export const PostScheduleBooking = (payload) => async (dispatch) => {
//     dispatch({ type: POST_SCHEDULE_BOOKING_REQUEST })
//     try {
//         const response = await ScheduleBookingService.PostScheduleBooking(payload)
//         if (response.data) {
//             dispatch({
//                 type: POST_SCHEDULE_BOOKING_SUCCESS,
//                 payload: response.data?.resultSet?.[0] || response.data?.result || response.data,
//             })
//             return response
//         }
//         dispatch({ type: POST_SCHEDULE_BOOKING_FAIL, payload: 'Booking submission failed' })
//         throw new Error('Booking submission failed')
//     } catch (error) {
//         dispatch({ type: POST_SCHEDULE_BOOKING_FAIL, payload: error?.response?.data?.message || error.message })
//         throw error
//     }
// }

// // straight line distance in km between two coordinates
// const haversineKm = (lat1, lon1, lat2, lon2) => {
//     const R = 6371
//     const toRad = (v) => (v * Math.PI) / 180
//     const dLat = toRad(lat2 - lat1)
//     const dLon = toRad(lon2 - lon1)
//     const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
// }

// export const FindNearestDriverAndSendRequest = (bookingId, requestedType, bookingPayload, authKey) => async (dispatch) => {
//     dispatch({ type: FIND_NEAREST_DRIVER_REQUEST })
//     try {
//         // fetch all three APIs at once
//         const [mainRes, waRes, vRes] = await Promise.all([
//             ScheduleBookingService.GetMainForkBookingDetails(),
//             ScheduleBookingService.GetWorkAreaDetails(),
//             ScheduleBookingService.GetVehicleDetails(),
//         ])

//         const mainBookings = mainRes.data?.resultSet || mainRes.data || []
//         const workAreas    = waRes.data?.resultSet   || waRes.data   || []
//         const vehicles     = vRes.data?.resultSet    || vRes.data    || []

//        // Find booking
//         const booking = mainBookings.find((b) => String(b.bId) === String(bookingId))
//         if (!booking)      throw new Error(`Booking ${bookingId} not found in GetMainForkBookingDetails`)
//         if (!booking.TO)   throw new Error(`Booking ${bookingId} has no TO location`)

//         //Compare booking details with work are lat long
//         const toArea = workAreas.find((w) => w.WAcode === booking.TO)
//         if (!toArea)       throw new Error(`Work area "${booking.TO}" not found in GetWorkAreaDetails`)
//         const toLat = parseFloat(toArea.lat)
//         const toLon = parseFloat(toArea.lon)
//         if (isNaN(toLat) || isNaN(toLon)) throw new Error(`No valid coordinates for work area "${booking.TO}"`)

//         // Valiodation
//         const candidates = vehicles.filter((v) =>
//             v.vehicleType?.toLowerCase() === requestedType?.toLowerCase() &&
//             v.status?.toLowerCase()      === 'active' &&
//             v.oStatus?.toLowerCase()     === 'online' &&
//             v.driverSno && v.latitude && v.longitude
//         )
//         if (!candidates.length) throw new Error(`No active online "${requestedType}" vehicles found`)

//         // Distance chek
//         const ranked = candidates
//             .map((v) => ({ ...v, distanceKm: parseFloat(haversineKm(parseFloat(v.latitude), parseFloat(v.longitude), toLat, toLon).toFixed(2)) }))
//             .sort((a, b) => a.distanceKm - b.distanceKm)

//         const nearest = ranked[0]
//         console.log('[FindNearest] nearest:', nearest.vehicleId, nearest.driverSno, nearest.distanceKm + 'km')

//         dispatch({ type: FIND_NEAREST_DRIVER_SUCCESS, payload: { nearest, toArea, ranked } })

//         // Web socket use to reuqest book
//         const bookingWS = (await import('../services/bookingWebSocket')).default
//         if (!bookingWS.isReady() && authKey) bookingWS.connectAsEmployee(authKey)

//         const sendNow = () => bookingWS.sendBooking({
//             ...bookingPayload,
//             vId:  nearest.vehicleId,
//             dSNo: nearest.driverSno,
//             BookingStatus: 'S',
//         })

//         if (bookingWS.isReady()) {
//             sendNow()
//         } else {
//             setTimeout(sendNow, 1500)
//         }

//         return nearest

//     } catch (error) {
//         console.error('[FindNearest]', error.message)
//         dispatch({ type: FIND_NEAREST_DRIVER_FAIL, payload: error.message })
//         throw error
//     }
// }

// export const ResetScheduleBookingForm = () => (dispatch) => {
//     dispatch({ type: RESET_SCHEDULE_BOOKING_FORM })
// }

import {
    POST_SCHEDULE_BOOKING_REQUEST,
    POST_SCHEDULE_BOOKING_SUCCESS,
    POST_SCHEDULE_BOOKING_FAIL,
    CHECK_AVAILABILITY_REQUEST,
    CHECK_AVAILABILITY_SUCCESS,
    CHECK_AVAILABILITY_FAIL,
    FIND_NEAREST_DRIVER_REQUEST,
    FIND_NEAREST_DRIVER_SUCCESS,
    FIND_NEAREST_DRIVER_FAIL,
    RESET_SCHEDULE_BOOKING_FORM,
} from '../constants/ScheduleBookingConstants'

import ScheduleBookingService from '../services/ScheduleBookingService'
import {
    getReservedVehicleIds,
    reserveVehicle,
    withAssignmentLock,
} from '../utils/assignmentLock'

// Hold a claim briefly past dispatch so the backend has time to reflect it.
const PROPAGATION_GRACE_MS = 30 * 1000

// CheckAvailability wants the date and the two times as separate values.
// bsTime/beTime arrive as "YYYY-MM-DD HH:MM:SS".
const splitBookingTime = (value) => {
    if (!value) return null
    const [datePart, timePart] = String(value).trim().split(/[ T]/)
    if (!datePart || !timePart) return null
    const hhmm = timePart.split(':').slice(0, 2).join(':')
    if (hhmm.length < 4) return null
    return { date: datePart, time: `${hhmm}:00` }
}


export { fetchWorkAreas as GetAllWorkAreas } from './WorkAreaActions'
export { fetchVehicles  as GetAllVehicles  } from './VehicleActions'

export const CheckVehicleAvailability = (vid, bdate, startTime, endTime) => async (dispatch) => {
    dispatch({ type: CHECK_AVAILABILITY_REQUEST })
    try {
        const fmt = (t) => t.split(':').length === 2 ? `${t}:00` : t
        const res = await ScheduleBookingService.CheckVehicleAvailability(vid, bdate, fmt(startTime), fmt(endTime))
        const isAvailable = res?.data?.resultSet?.[0]?.Availability === 'Available'
        dispatch({ type: CHECK_AVAILABILITY_SUCCESS, payload: isAvailable })
        return isAvailable
    } catch (error) {
        dispatch({ type: CHECK_AVAILABILITY_FAIL, payload: error?.response?.data?.message || error.message })
        return false
    }
}

export const PostScheduleBooking = (payload) => async (dispatch) => {
    dispatch({ type: POST_SCHEDULE_BOOKING_REQUEST })
    try {
        const response = await ScheduleBookingService.PostScheduleBooking(payload)
        if (response.data) {
            dispatch({
                type: POST_SCHEDULE_BOOKING_SUCCESS,
                payload: response.data?.resultSet?.[0] || response.data?.result || response.data,
            })
            return response
        }
        dispatch({ type: POST_SCHEDULE_BOOKING_FAIL, payload: 'Booking submission failed' })
        throw new Error('Booking submission failed')
    } catch (error) {
        dispatch({ type: POST_SCHEDULE_BOOKING_FAIL, payload: error?.response?.data?.message || error.message })
        throw error
    }
}

// straight line distance in km between two coordinates
const haversineKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371
    const toRad = (v) => (v * Math.PI) / 180
    const dLat = toRad(lat2 - lat1)
    const dLon = toRad(lon2 - lon1)
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

// TC-02 / TC-03 for real-time ("unplanned") bookings.
//
// This path used to rank candidates purely by straight-line distance to the
// destination work area and immediately dispatch the winner over the socket.
// It never asked whether that vehicle was already booked, so two employees
// requesting at the same time both got the same forklift — and because the
// ranking is a pure function of the destination, two requests to the SAME
// location produced an identical ordering and therefore always collided.
//
// Now: reserved vehicles are excluded up front, and the ranked list is walked
// until one is confirmed free via CheckAvailability and successfully claimed.
export const FindNearestDriverAndSendRequest = (bookingId, requestedType, bookingPayload, authKey, excludeVehicleIds = []) => async (dispatch) =>
  withAssignmentLock(async () => {
    dispatch({ type: FIND_NEAREST_DRIVER_REQUEST })
    // Hoisted so the catch below can release it on any failure path.
    let claim = null
    try {
        // fetch all three APIs at once
        const [mainRes, waRes, vRes] = await Promise.all([
            ScheduleBookingService.GetMainForkBookingDetails(),
            ScheduleBookingService.GetWorkAreaDetails(),
            ScheduleBookingService.GetVehicleDetails(),
        ])

        const mainBookings = mainRes.data?.resultSet || mainRes.data || []
        const workAreas    = waRes.data?.resultSet   || waRes.data   || []
        const vehicles     = vRes.data?.resultSet    || vRes.data    || []

       // Find booking
        const booking = mainBookings.find((b) => String(b.bId) === String(bookingId))
        if (!booking)      throw new Error(`Booking ${bookingId} not found in GetMainForkBookingDetails`)
        if (!booking.TO)   throw new Error(`Booking ${bookingId} has no TO location`)

        //Compare booking details with work are lat long
        const toArea = workAreas.find((w) => w.WAcode === booking.TO)
        if (!toArea)       throw new Error(`Work area "${booking.TO}" not found in GetWorkAreaDetails`)
        const toLat = parseFloat(toArea.lat)
        const toLon = parseFloat(toArea.lon)
        if (isNaN(toLat) || isNaN(toLon)) throw new Error(`No valid coordinates for work area "${booking.TO}"`)

        // Booking window — needed both for the availability check and to scope
        // the reservation. Prefer the caller's payload; fall back to the record.
        const slotStart = bookingPayload?.bsTime || booking.bsTime || booking.BsTime
        const slotEnd   = bookingPayload?.beTime || booking.beTime || booking.BeTime
        const startParts = splitBookingTime(slotStart)
        const endParts   = splitBookingTime(slotEnd)

        // Build exclusion set — skip vehicles whose drivers already declined
        const excludeSet = new Set(
            (excludeVehicleIds || []).map((id) => String(id).trim())
        )

        // ...plus anything claimed by an assignment still in flight. Without
        // this, two requests ranked moments apart both see the same winner.
        getReservedVehicleIds(slotStart, slotEnd, { ignoreBookingId: bookingId })
            .forEach((id) => excludeSet.add(id))

        // Filter: correct type, active, online, has driver+GPS, not in exclusion list
        const candidates = vehicles.filter((v) =>
            v.vehicleType?.toLowerCase() === requestedType?.toLowerCase() &&
            v.status?.toLowerCase()      === 'active' &&
            v.oStatus?.toLowerCase()     === 'online' &&
            v.driverSno && v.latitude && v.longitude &&
            !excludeSet.has(String(v.vehicleId || '').trim())
        )
        if (!candidates.length) throw new Error(`No available "${requestedType}" drivers remaining (all candidates may have declined)`)

        // Distance chek
        const ranked = candidates
            .map((v) => ({ ...v, distanceKm: parseFloat(haversineKm(parseFloat(v.latitude), parseFloat(v.longitude), toLat, toLon).toFixed(2)) }))
            .sort((a, b) => a.distanceKm - b.distanceKm)

        // Walk the ranked list nearest-first and take the first vehicle that is
        // both free for the slot and not already claimed. Previously this just
        // took ranked[0] with no availability check whatsoever.
        let nearest = null
        const skipped = []

        for (const candidate of ranked) {
            if (startParts && endParts) {
                let available = true
                try {
                    const res = await ScheduleBookingService.CheckVehicleAvailability(
                        candidate.vehicleId,
                        startParts.date,
                        startParts.time,
                        endParts.time
                    )
                    available = res?.data?.resultSet?.[0]?.Availability === 'Available'
                } catch (err) {
                    // Match the rest of the codebase: assume free on API error
                    // rather than stalling every booking when this endpoint is flaky.
                    console.error('[FindNearest] availability check failed for', candidate.vehicleId, err.message)
                }
                if (!available) {
                    skipped.push(candidate.vehicleId)
                    continue
                }
            }

            claim = reserveVehicle(candidate.vehicleId, slotStart, slotEnd, bookingId)
            if (!claim) {
                skipped.push(candidate.vehicleId)
                continue
            }
            nearest = candidate
            break
        }

        if (!nearest) {
            const err = new Error(
                `No available "${requestedType}" vehicle for this time slot` +
                (skipped.length ? ` (${skipped.length} already booked)` : '')
            )
            err.code = 'ALL_VEHICLES_BUSY'
            err.busyCount = skipped.length
            throw err
        }

        if (skipped.length) {
            console.log('[FindNearest] skipped already-booked vehicles:', skipped.join(', '))
        }
        console.log('[FindNearest] nearest:', nearest.vehicleId, nearest.driverSno, nearest.distanceKm + 'km')

        dispatch({ type: FIND_NEAREST_DRIVER_SUCCESS, payload: { nearest, toArea, ranked } })

        // Web socket use to reuqest book
        const bookingWS = (await import('../services/bookingWebSocket')).default
        if (!bookingWS.isReady() && authKey) bookingWS.connectAsEmployee(authKey)

        const sendNow = () => bookingWS.sendBooking({
            ...bookingPayload,
            vId:  nearest.vehicleId,
            dSNo: nearest.driverSno,
            BookingStatus: 'S',
        })

        if (bookingWS.isReady()) {
            sendNow()
        } else {
            setTimeout(sendNow, 1500)
        }

        // Keep the claim alive past the socket send (which may itself be delayed
        // 1.5s above) so a request issued right behind this one cannot pick the
        // same vehicle before the backend has registered it.
        setTimeout(claim.release, PROPAGATION_GRACE_MS)

        return nearest

    } catch (error) {
        // Never leave a vehicle blocked by an assignment that did not happen.
        if (claim) claim.release()
        console.error('[FindNearest]', error.message)
        dispatch({ type: FIND_NEAREST_DRIVER_FAIL, payload: error.message })
        throw error
    }
  })

export const ResetScheduleBookingForm = () => (dispatch) => {
    dispatch({ type: RESET_SCHEDULE_BOOKING_FORM })
}